import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "diem_den_an_toan_check_in";

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.findById = (id, fields) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id, fields: fields },
    };
    return ApiService(api);
};

moduleApi.getKhachDuLich = (data) => {
  let api = {
    module: moduleName,
    type: "getKhachDuLich",
    value: data,
    message: {
      success: "hidden", //string | null | comment
      error: "hidden", //string | null | comment
    }
  };
  return ApiService(api);
};

export default moduleApi;
